// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const GlobalCss = css`
  margin: 0 0 37px 0;
  ::after {
    content: '';
    height: 1px;
    width: 80px;
    background: ${(props) => props.theme.brandSpecificStyles.FOOTER_NAV_HEADER_BACKGROUND_COLOR};
    border: 10px;
    display: block;
    margin-top: 14px;
  }
  &.img-link {
    ::after {
      display: none;
    }
    img {
      max-height: 80px;
    }
  }
  &.subHeader {
    margin-top: 24px;
  }
  &.footNavHearNewCls {
    color: #000;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 18px */
    text-transform: capitalize;
    margin: 0;
    ::after {
      content: none;
    }
  }
`;

export default GlobalCss;
